// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "95f5b83df7137778abd1989924ac5ed9942658b0",
  version: "1.123.5",
};
